'use client';

import {
  type SupportLauncherId,
  useJarvisSupportLauncherState,
} from './useJarvisSupportLauncherState';

export type { SupportLauncherId };

export function useSupportLauncherId(): SupportLauncherId {
  return useJarvisSupportLauncherState().launcherId;
}
